import axios from "axios";

export function handleAxiosError(error: any): any {

  if (axios.isAxiosError(error) && error.response) {
    console.log(error.response)
    return error.response.data;
  }
  return {
    success: false,
    status: 500,
    message: error.message || "Une erreur inattendue est survenue.",
    data: null,
    path: '',
    timestamp: new Date().toISOString()
  };
}